export default {
  title: '选择生产批次',
};
